import { setDocumentTitle, setUidToken, showConsole } from 'src/helper/tool'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import { unix2date6, unix2date7 } from 'src/helper/time'
import forbidScroll from 'src/tools/forbidScroll'
import { jumpToUser, jumpToRoom, openViewTransparent, jumpToWallet, closeWebViewPage, closeWebview, jumpToTab, jumpToGames, onWebViewShow, jumpToRoomNew } from '../helper/webviewFun'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import { inject, observer, toJS } from 'src/core/store'

export {
  setDocumentTitle,
  setUidToken,
  showConsole,
  getlang,
  setlang,
  score,
  unix2date6,
  forbidScroll,
  jumpToUser,
  jumpToRoom,
  debounce,
  throttle,
  inject,
  observer,
  openViewTransparent,
  jumpToWallet,
  closeWebViewPage,
  closeWebview,
  toJS,
  jumpToTab,
  jumpToGames,
  onWebViewShow,
  jumpToRoomNew,
  unix2date7
}



// WEBPACK FOOTER //
// src/helper/devTools.js